import React from 'react'

const HomeTextbox = () => {
  return (
    <div className='home-text' style={{ margin: '10px', textAlign: 'justify', lineHeight: '1.2', fontFamily:'NotoSansRegular' }}>
      <p style={{ marginBottom: '20px' }}>
        DuPont™ Nomex® Comfort with EcoForce™ technology delivers best-in-class flame resistance and chemical protection while addressing growing environmental concerns about personal protective equipment (PPE). With its multi-hazard protection, it takes the sustainability of PPE to the next level. The fabric’s chemical-repellent finish is made from over 50% bio-based materials and is not based on fluorine chemistry.
      </p>
      <p style={{ marginBottom: '20px' }}>
        Additionally, DuPont’s fabric is highly durable, thanks to its inherent FR protection that cannot be washed or worn away. Nomex® Comfort with EcoForce™ technology is certified and continues to maintain its performance in accordance with the initial requirements of EN 13034, EN ISO 11612 and EN 1149-5, even after 100 industrial washing cycles (according to the ISO 15797 standard, for specific chemicals). These characteristics increase the long-lasting wear life of the fabric decreasing the need for frequent replacements, which also helps to decrease waste.
      </p>
      <p style={{ marginBottom: '20px' }}>
        Nomex Comfort with Ecoforce is available in 204g/m² and 224g/m² and is typically used for FR coveralls, jackets and trousers.
      </p>
    </div>
  );
};

export default HomeTextbox;
